if (document.readyState == 'complete') {
  //Implementation for purchase options tabs navigation
  initializePurchaseOptionsTabs();
} else {
  window.addEventListener('load', function () {
    initializePurchaseOptionsTabs();
  });
}

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

function toggleScrollButtons(tabListWrapper, btnLeft, btnRight) {
  const maxScroll = calculateMaxScroll(tabListWrapper);
  const scrollLeft = tabListWrapper.scrollLeft;
  if (btnRight) {
    if (scrollLeft >= maxScroll * 0.95) {
      btnRight.classList.add('d-none');
    } else {
      btnRight.classList.remove('d-none');
    }
  }
  if (btnLeft) {
    if (scrollLeft > 0) {
      btnLeft.classList.remove('d-none');
    } else {
      btnLeft.classList.add('d-none');
    }
  }
}

function initializePurchaseOptionsTabs() {
  const PURCHASE_OPTIONS_SELECTOR = '.purchase-options-tabs .tabs-container';
  const TAB_LIST_WRAPPER_SELECTOR = '.nav-tabs-wrapper';
  const TAB_LIST_SELECTOR = 'ul.nav-tabs';
  const SCROLL_LEFT_BTN_SELECTOR = '.left-scroll-btn';
  const SCROLL_RIGHT_BTN_SELECTOR = '.right-scroll-btn';

  const tabsContainers = document.querySelectorAll(PURCHASE_OPTIONS_SELECTOR);
  if (!tabsContainers || tabsContainers.length === 0) {
    return;
  }
  tabsContainers.forEach((tabContainer) => {
    const tabListWrapper = tabContainer.querySelector(TAB_LIST_WRAPPER_SELECTOR);
    //the .nav-tabs-wrapper contains the overflow scroll
    if (tabListWrapper) {
      const tabList = tabContainer.querySelector(TAB_LIST_SELECTOR);
      const btnLeft = tabContainer.querySelector(SCROLL_LEFT_BTN_SELECTOR);
      const btnRight = tabContainer.querySelector(SCROLL_RIGHT_BTN_SELECTOR);
      handleTabNavigation(tabList);
      //scroll to activate tab on load
      scrollToActiveTab(tabListWrapper);
      //initial update of scroll buttons on page load
      toggleScrollButtons(tabListWrapper, btnLeft, btnRight);
      //add scroll listener to update button visibility on scroll
      addScrollButtonListener(tabListWrapper, btnLeft, btnRight);
      //add click listeners to scroll buttons
      addClickButtonListeners(tabListWrapper, btnLeft, btnRight);
      setBadgeWidths(tabList);
    }
  });

  //resize / zoom scenario
  const debouncedResize = debounce(() => {
    tabsContainers.forEach((tabContainer) => {
      //tabListWrapper contains the overflow scroll
      const tabListWrapper = tabContainer.querySelector(TAB_LIST_WRAPPER_SELECTOR);
      if (tabListWrapper) {
        const tabList = tabContainer.querySelector(TAB_LIST_SELECTOR);
        const btnLeft = tabContainer.querySelector(SCROLL_LEFT_BTN_SELECTOR);
        const btnRight = tabContainer.querySelector(SCROLL_RIGHT_BTN_SELECTOR);
        toggleScrollButtons(tabListWrapper, btnLeft, btnRight);
        setBadgeWidths(tabList);
      }
    });
  }, 100);

  //set resize listener to recalculate maxScroll on window resize (zoom event)
  window.removeEventListener('resize', debouncedResize);
  window.addEventListener('resize', debouncedResize);
}

// This block handles tab behaviors to match a11y requirements
// Function that will handle tab navigation
// TODO: Remove this when update to Bootstrap 5.2.3
function handleTabNavigation(tabList) {
  const rawButtons = tabList.querySelectorAll('button.nav-link');
  const tabButtons = Array.from(rawButtons);
  let selectedButton = tabButtons.find((tab) => tab.classList.contains('active'));
  // Function to update which button is selected
  function updateSelectedButton(newSelectedButton) {
    tabButtons.forEach((button) => {
      if (button === newSelectedButton) {
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');
        button.tabIndex = 0;
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-selected', 'false');
        button.tabIndex = -1;
      }
    });
    selectedButton = newSelectedButton;
  }
  updateSelectedButton(selectedButton);
  // Add click listeners to update selected button
  tabButtons.forEach((tab) => {
    tab.addEventListener('click', () => {
      updateSelectedButton(tab);
    });
    tab.addEventListener('focus', () => {
      //set scroll into view on focus to improve keyboard navigation
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });
}

function scrollToActiveTab(tabList) {
  const navLink = tabList.querySelector('.nav-item:has(.nav-link.active)');
  tabList.scrollTo({ left: navLink.offsetLeft, behavior: 'smooth' });
}

function addScrollButtonListener(tabListWrapper, btnLeft, btnRight) {
  const debouncedScroll = debounce(() => {
    toggleScrollButtons(tabListWrapper, btnLeft, btnRight);
  }, 50);
  tabListWrapper.addEventListener('scroll', debouncedScroll);
}

function addClickButtonListeners(tabListWrapper, btnLeft, btnRight) {
  const handleScrollClick = (tabListWrapper, direction) => {
    const scrollStep = tabListWrapper.scrollWidth / 1.5;
    const scrollAmount = direction === 'left' ? -scrollStep : scrollStep;
    tabListWrapper.scrollTo({ left: tabListWrapper.scrollLeft + scrollAmount, behavior: 'smooth' });
    setTimeout(() => {
      toggleScrollButtons(tabListWrapper, btnLeft, btnRight);
    }, 150);
  };

  if (btnLeft) {
    btnLeft.addEventListener('click', () => handleScrollClick(tabListWrapper, 'left'));
  }
  if (btnRight) {
    btnRight.addEventListener('click', () => handleScrollClick(tabListWrapper, 'right'));
  }
}

function setBadgeWidths(tabList) {
  tabList.querySelectorAll('.nav-item .badge').forEach((badgeEl) => {
    const nextElement = badgeEl.nextElementSibling;
    if (nextElement) {
      badgeEl.style.width = `${nextElement.clientWidth}px`;
    }
  });
}

function calculateMaxScroll(wrapper) {
  return wrapper.scrollWidth - wrapper.offsetWidth;
}
